import React from 'react';
import { Card, CardContent, CardMedia, Typography, Box, Button } from '@mui/material';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';

const ProductCard = ({ image, title, onKnowMore }) => {
  return (
    <Box sx={{ position: 'relative', width: '100%', maxWidth: '100%', height: '100%' }}>
      <Card sx={{
        boxShadow: '0 10px 30px rgba(0,0,0,0.08)',
        borderRadius: '12px',
        overflow: 'hidden',
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        transition: 'all 0.3s ease',
        border: '1px solid rgba(0,0,0,0.05)',
        '&:hover': {
          transform: 'translateY(-8px) scale(1.02)',
          boxShadow: '0 20px 40px rgba(124, 0, 31, 0.12)',
          borderColor: 'rgba(124, 0, 31, 0.2)'
        }
      }}>
        <Box sx={{ overflow: 'hidden', height: 280, position: 'relative', backgroundColor: '#fff', p: 2 }}>
          <CardMedia
            component="img"
            image={image}
            alt={title}
            sx={{
              height: '100%',
              width: '100%',
              objectFit: 'contain',
              transition: 'transform 0.5s ease',
              '&:hover': {
                transform: 'scale(1.1)',
              }
            }}
          />
        </Box>

        <CardContent sx={{
          p: 3,
          flexGrow: 1,
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-between',
          backgroundColor: '#ffffff'
        }}>
          <Typography
            variant="h6"
            component="div"
            sx={{
              fontWeight: 700,
              fontFamily: 'Inter, sans-serif',
              mb: 2,
              color: '#1a1a1a',
              fontSize: '1.1rem',
              lineHeight: 1.4
            }}
          >
            {title}
          </Typography>

          <Box sx={{ mt: 'auto', pt: 2 }}>
            <Button
              onClick={onKnowMore}
              variant="contained"
              endIcon={<ArrowForwardIcon />}
              sx={{
                backgroundColor: '#7C001F',
                color: 'white',
                borderRadius: '8px',
                textTransform: 'none',
                fontWeight: 600,
                fontSize: '0.95rem',
                padding: '10px 24px',
                width: '100%',
                boxShadow: '0 4px 12px rgba(124, 0, 31, 0.2)',
                '&:hover': {
                  backgroundColor: '#5C001F',
                  boxShadow: '0 6px 16px rgba(124, 0, 31, 0.3)',
                }
              }}
            >
              Know More
            </Button>
          </Box>
        </CardContent>
      </Card>
    </Box>
  );
};

export default ProductCard;